var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWatchIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "12px",
    viewBox: "0 0 19 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "view (2)") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Leads-Lead-Details",
    transform: "translate(-1387.000000, -86.000000)",
    fill: "#4F4F4F",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "view-(2)",
    transform: "translate(1387.761330, 86.467570)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.911165,5.39385732 C17.7501302,5.17356983 13.9132128,0 9.01277556,0 C4.11233828,0 0.275244942,5.17356983 0.114386137,5.39364608 C-0.0381287122,5.60263227 -0.0381287122,5.88608034 0.114386137,6.09506652 C0.275244942,6.31535401 4.11233828,11.4889238 9.01277556,11.4889238 C13.9132128,11.4889238 17.7501302,6.3153188 17.911165,6.09524255 C18.0638911,5.88629158 18.0638911,5.60263227 17.911165,5.39385732 Z M9.01277556,10.3004205 C5.40308144,10.3004205 2.27670308,6.86661844 1.35122805,5.74405705 C2.27550605,4.62050987 5.395336,1.18850329 9.01277556,1.18850329 C12.6222937,1.18850329 15.7484608,4.62170689 16.6743231,5.7448668 C15.7500451,6.86837877 12.6302151,10.3004205 9.01277556,10.3004205 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.01277556,2.17893444 C7.04677044,2.17893444 5.44723048,3.7784744 5.44723048,5.74447952 C5.44723048,7.71048465 7.04677044,9.31002461 9.01277556,9.31002461 C10.9787807,9.31002461 12.5783206,7.71048465 12.5783206,5.74447952 C12.5783206,3.7784744 10.9787807,2.17893444 9.01277556,2.17893444 Z M9.01277556,8.12148611 C7.70203507,8.12148611 6.63576898,7.05518481 6.63576898,5.74447952 C6.63576898,4.43377424 7.70207028,3.36747294 9.01277556,3.36747294 C10.3234809,3.36747294 11.3897821,4.43377424 11.3897821,5.74447952 C11.3897821,7.05518481 10.3235161,8.12148611 9.01277556,8.12148611 Z",
    id: "Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWatchIcon);
export default __webpack_public_path__ + "static/media/watch-icon.9369e22f5220b635e46893efa4229e5c.svg";
export { ForwardRef as ReactComponent };